import { gql } from "@apollo/client";

export const CREATE_STACK = gql`
  mutation CreateStack($input: StackInput!, $manageState: Boolean!, $stackObjectID: String) {
    stackCreate(input: $input, manageState: $manageState, stackObjectID: $stackObjectID) {
      id
    }
  }
`;
